export const handleFocus = (event) => event.target.select()
